import React from 'react';
import FacilityAvailabilityDashboard from '../../components/facilities/FacilityAvailabilityDashboard';
import './AvailabilityDashboardPage.css';

const AvailabilityDashboardPage = () => {
  return (
    <div className="availability-dashboard-page">
      <FacilityAvailabilityDashboard />
    </div>
  );
};

export default AvailabilityDashboardPage;